import styled from "styled-components";

export const Container = styled.div`
  width: 300px;
  background: white;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.2);
  cursor: pointer;
  @media screen and (max-width: 480px) {
    width: 230px;
    margin-bottom: 10px;
  }
`;
export const Top = styled.div`
  height: 200px;
  width: 100%;
  @media screen and (max-width: 480px) {
    height: 145px;
  }
`;
export const Image = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
`;
export const Bottom = styled.div`
  padding: 10px;
  // border: 1px solid #827777;
`;
export const Time = styled.p`
  color: #827777;
  margin-bottom: 5px;
  font-weight: 300;
  @media screen and (max-width: 480px) {
    font-size: 11px;
  }
`;
export const Title = styled.p`
  font-size: 28px;
  margin-bottom: 10px;
  @media screen and (max-width: 480px) {
    font-size: 16px;
  }
`;
export const Desc = styled.p`
  margin-bottom: 10px;
  text-align: justify;
  text-justify: inter-word;
  font-weight: 300;
  @media screen and (max-width: 480px) {
    font-size: 11px;
  }
`;
export const Read = styled.span`
  @media screen and (max-width: 480px) {
    font-size: 11px;
  }
`;
